<template>
  <router-view @authSuccess="onAuthSuccess" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { useContext, VBCShellContext } from '@/modules/context';

export default defineComponent({
  setup() {
    const router = useRouter();
    const { setVBCShellContext } = useContext();

    function onAuthSuccess(context: VBCShellContext) {
      if (context) {
        console.log(`loaded vbc-shell-client with context ${JSON.stringify(context)}`);
        setVBCShellContext(context);
      }
      router.replace({ name: 'Home' });
    }

    return {
      onAuthSuccess,
    };
  },
});
</script>

<style>
html {
  height: 100%;
}

body {
  height: 100%;
  margin: 0;
}

/* Used to style the application root element inside index.html */
#app {
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
}
</style>
